const ACTION_EVENT = {
  SET_PROFILE: "SET_PROFILE",
  SET_NEW_PROFILE: "SET_NEW_PROFILE",
  SET_NEW_BUNDLE_PROFILE: "SET_NEW_BUNDLE_PROFILE",
  SET_NOTIFICATION: "SET_NOTIFICATION",
  SET_PROFILE_DETAILS: "SET_PROFILE_DETAILS",
  SET_PROFILE_PICTURE: "SET_PROFILE_PICTURE",
  SET_PROFILE_TEST_OPTIONS: "SET_PROFILE_TEST_OPTIONS",
  SET_PROFILE_FONT_OPTIONS: "SET_PROFILE_FONT_OPTIONS",
  SET_TEST_HISTORY: "SET_TEST_HISTORY",
  DELETE_TEST_HISOTRY: "DELETE_TEST_HISOTRY",
  ADD_FLASHCARD_TO_BOOKMARK: "ADD_FLASHCARD_TO_BOOKMARK",
  REMOVE_FLASHCARD_FROM_BOOKMARK: "REMOVE_FLASHCARD_FROM_BOOKMARK",
  ADD_FLASHCARD_PROGRESS: "ADD_FLASHCARD_PROGRESS",
  ADD_QUESTION_TO_BOOKMARK: "ADD_QUESTION_TO_BOOKMARK",
  REMOVE_QUESTION_FROM_BOOKMARK: "REMOVE_QUESTION_FROM_BOOKMARK",
  ADD_QUESTION_PROGRESS: "ADD_QUESTION_PROGRESS",
  ADD_ARTICLE_TO_BOOKMARK: "ADD_ARTICLE_TO_BOOKMARK",
  REMOVE_ARTICLE_FROM_BOOKMARK: "REMOVE_ARTICLE_FROM_BOOKMARK",
  ADD_ARTICLE_PROGRESS: "ADD_ARTICLE_PROGRESS",
  SET_PRACTICE_TEST_INITIAL_VALUE: "SET_PRACTICE_TEST_INITIAL_VALUE",
  ON_CHANGE_QUESTION: "ON_CHANGE_QUESTION",
  ON_CHANGE_TIME: "ON_CHANGE_TIME",
  RESET_TEST: "RESET_TEST",
  ON_UPDATE_QUESTIONS_SCROE: "ON_UPDATE_QUESTIONS_SCROE",
  ON_UPDATE_COMMUNITY_DATA: "ON_UPDATE_COMMUNITY_DATA",
  ON_UPDATE_ALL_COMMUNITY_DATA: "ON_UPDATE_ALL_COMMUNITY_DATA",
  SET_COMMUNITY_DATA: "SET_COMMUNITY_DATA",
  ON_TAB_PRESS: "ON_TAB_PRESS",
  ON_CHECK_REVIEW: "ON_CHECK_REVIEW",
  SET_ALL_QUESTION_SCORE: "SET_ALL_QUESTION_SCORE",
  SET_LOADER: "SET_LOADER",
  SET_EXAM_DATE_DETAILS: "SET_EXAM_DATE_DETAILS",

};

const USER_DEAFULT_KEY = {
  QUESTION_VERSION: "QUESTION_VERSION",
  QUESTION_DATA: "QUESTION_DATA",
  IS_TEST_REVIEW_DONE: "IS_TEST_REVIEW_DONE",
  IS_TEST_REVIEW_NEXT_DATE: "IS_TEST_REVIEW_NEXT_DATE",
  SAVED_BUNDLE_DETAILS: "SAVED_BUNDLE_DETAILS",
};

export { ACTION_EVENT, USER_DEAFULT_KEY };
